import { RowClassParams, ValueFormatterParams } from "ag-grid-community";
import React from "react";
import { GridType } from "../../../../../types/grid";
import Grid from "../../../../atoms/Grid";
import { DecimalUtils, formatCurrency, formatDateByType, formatNumber } from "../../../../libs/utils";
import type { GetBillingScheduleResult } from "../Commercial/add-plan/api";

type ViewBillingScheduleProps = {
  rows: GetBillingScheduleResult["baseRentPaymentSchedule"];
};

const columns: GridType[] = [
  {
    id: "installment",
    field: "installment",
    headerName: "Inst #",
    flex: 1,
  },
  {
    id: "startDate",
    field: "startDate",
    headerName: "From",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value),
  },
  {
    id: "endDate",
    field: "endDate",
    headerName: "To",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value),
  },
  {
    id: "dueDate",
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value),
  },
  {
    id: "baseRent",
    field: "baseRent",
    headerName: "Base Rent",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams) => formatCurrency(value),
  },
  {
    id: "vat",
    field: "vat",
    headerName: "VAT",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams) => formatCurrency(value),
  },
  {
    id: "vatInPercentage",
    field: "vatInPercentage",
    headerName: "VAT %",
    flex: 0.7,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams) => formatNumber(value),
  },
  {
    id: "total",
    field: "total",
    headerName: "Total",
    flex: 1.3,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams) => formatCurrency(value),
  },
];

export const ViewBillingSchedule = ({ rows }: ViewBillingScheduleProps) => {
  const totalBaseRent = DecimalUtils.add(rows.map((r) => r.baseRent));
  const totalVat = DecimalUtils.add(rows.map((r) => r.vat));
  const totalTotal = DecimalUtils.add(rows.map((r) => r.total));

  const grandTotalPinnedRow = [
    {
      installment: "Grand Total",
      baseRent: totalBaseRent,
      vat: totalVat,
      total: totalTotal,
    },
  ];

  return (
    <Grid
      fullPage
      className="p-0"
      columns={columns}
      data={rows}
      pinnedBottomRowData={grandTotalPinnedRow}
      getRowStyle={({ node }: RowClassParams) => {
        if (node.rowPinned === "bottom") return { background: "var(--gray-100)", fontWeight: 600 };
      }}
    />
  );
};
